import { useId } from 'react';

// Stand-in for Figma "Competitive play" — replace with the design export when it lands.
export default function GameTypeCompetitive({ className }: { className?: string }) {
  const id = `game-type-competitive-${useId().replace(/:/g, '')}`;

  return (
    <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4 1.9C12.9 5.4 15.7 8 15.7 11.9C15.7 15.2 13.2 17.9 10 17.9C6.8 17.9 4.3 15.2 4.3 11.9C4.3 9.3 5.8 7.2 7.5 5.7C7.25 7.3 7.8 8.7 8.85 9.1C9.9 9.5 10.75 8.65 10.75 7.4C10.75 5.5 10.4 3.8 10.4 1.9Z"
        fill={`url(#${id}-outer)`}
      />
      <path
        d="M10.4 1.9C12.9 5.4 15.7 8 15.7 11.9C15.7 15.2 13.2 17.9 10 17.9C6.8 17.9 4.3 15.2 4.3 11.9C4.3 9.3 5.8 7.2 7.5 5.7C7.25 7.3 7.8 8.7 8.85 9.1C9.9 9.5 10.75 8.65 10.75 7.4C10.75 5.5 10.4 3.8 10.4 1.9Z"
        fill={`url(#${id}-glow)`}
      />
      <path
        d="M10 10.2C11.5 11.9 12.5 13 12.5 14.5C12.5 16.2 11.35 17.3 10 17.3C8.65 17.3 7.5 16.2 7.5 14.5C7.5 13.1 8.4 12 10 10.2Z"
        fill={`url(#${id}-core)`}
      />
      <defs>
        <radialGradient
          id={`${id}-outer`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.6 14.6) rotate(-84) scale(14.4 10.6)"
        >
          <stop stopColor="#FFB01F" />
          <stop offset="0.44" stopColor="#FF7A22" />
          <stop offset="1" stopColor="#E4452F" />
        </radialGradient>
        <radialGradient
          id={`${id}-glow`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10 1.6) rotate(90) scale(17.2 11.8)"
        >
          <stop offset="0.72" stopColor="#F2622A" stopOpacity="0" />
          <stop offset="1" stopColor="#C9343D" />
        </radialGradient>
        <radialGradient
          id={`${id}-core`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10 16.4) rotate(-90) scale(7 5.2)"
        >
          <stop stopColor="#FFF07A" />
          <stop offset="0.62" stopColor="#FFC62E" />
          <stop offset="1" stopColor="#FF9A1F" />
        </radialGradient>
      </defs>
    </svg>
  );
}
